/**
 * ProjectilePath enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ProjectilePath.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ProjectilePath {
  DEFAULT        = 0,
  HOMING         = 1,
  BALLISTIC      = 2,
  HIGH_BALLISTIC = 3,
  ACCELERATING   = 4,
}